"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDirectLineCDNUrl = exports.getACSAdapterCDNUrl = exports.getIC3AdapterCDNUrl = exports.getIC3ClientCDNUrl = void 0;
var settings_1 = require("../config/settings");
var getIC3ClientCDNUrl = function (version) {
    if (version === void 0) { version = settings_1.ic3ClientVersion; }
    var IC3ClientCDNUrl = "https://comms.omnichannelengagementhub.com/release/".concat(version, "/Scripts/SDK/SDK.min.js");
    return IC3ClientCDNUrl;
};
exports.getIC3ClientCDNUrl = getIC3ClientCDNUrl;
var getIC3AdapterCDNUrl = function (version) {
    if (version === void 0) { version = settings_1.webChatIC3AdapterVersion; }
    var IC3AdapterCDNUrl = "https://webchatic3.blob.core.windows.net/webchat-ic3adapter/".concat(version, "/botframework-webchat-adapter-ic3.production.min.js");
    return IC3AdapterCDNUrl;
};
exports.getIC3AdapterCDNUrl = getIC3AdapterCDNUrl;
var getACSAdapterCDNUrl = function (version) {
    if (version === void 0) { version = settings_1.webChatACSAdapterVersion; }
    var ACSAdapterCDNUrl = "https://unpkg.com/acs_webchat-chat-adapter@".concat(version, "/dist/chat-adapter.js");
    return ACSAdapterCDNUrl;
};
exports.getACSAdapterCDNUrl = getACSAdapterCDNUrl;
var getDirectLineCDNUrl = function (version) {
    if (version === void 0) { version = settings_1.webChatDirectLineVersion; }
    var DirectLineCDNUrl = "https://unpkg.com/botframework-directlinejs@".concat(version, "/dist/directline.js");
    return DirectLineCDNUrl;
};
exports.getDirectLineCDNUrl = getDirectLineCDNUrl;
exports.default = {
    getIC3ClientCDNUrl: getIC3ClientCDNUrl,
    getIC3AdapterCDNUrl: getIC3AdapterCDNUrl,
    getACSAdapterCDNUrl: getACSAdapterCDNUrl,
    getDirectLineCDNUrl: getDirectLineCDNUrl
};
//# sourceMappingURL=libraries.js.map